import React, { useEffect, useState } from "react";
import api, { asArray, fileUrl } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";
import useReveal from "../hooks/useReveal";

export default function ClientsPage() {
    const { t, pick } = useI18n();
    const ref = useReveal();
    const [clients, setClients] = useState([]);

    useEffect(() => {
        api.get("/clients").then((r) => setClients(asArray(r.data, "clients"))).catch(() => {});
    }, []);

    return (
        <div ref={ref} data-testid="clients-page">
            <section className="clients-page-hero bg-[#EFF0F1] py-20 md:py-28">
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <div className="section-eyebrow mb-5 plus-mark">
                        {t("section_clients_overline")}
                    </div>
                    <h1 className="heading page-hero-oneline">
                        {t("section_clients_title")}
                    </h1>
                </div>
            </section>

            <section className="clients-page-body py-16 md:py-24">
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <div className="clients-page-grid reveal" data-testid="clients-logo-list">
                        {clients.map((client, i) => (
                            <div key={client.id || pick(client, "name") || i} className="client-page-card" style={{ "--delay": `${i * 25}ms` }}>
                                {client.logo ? (
                                    <img
                                        src={fileUrl(client.logo)}
                                        alt={pick(client, "name")}
                                        loading="lazy"
                                        decoding="async"
                                        className="client-page-logo"
                                    />
                                ) : (
                                    <span className="client-page-name">
                                        {pick(client, "name")}
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
